import { render, staticRenderFns } from "./OwnerField.vue?vue&type=template&id=0f3b4e6c&scoped=true&"
import script from "./OwnerField.vue?vue&type=script&lang=js&"
export * from "./OwnerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b4e6c",
  null
  
)

export default component.exports